import CustomHead from 'components/common/HeadMeta/HeadMeta'
import Template from 'components/download-completed'
import useLocalStorage from 'hooks/useLocalStorage'

const DownloadCompleted: React.FC = () => {
  const fromCorrectFormPage = useLocalStorage('refDownloadAIDrivenDevelopmentPage')

  return (
    <>
      {fromCorrectFormPage && (
        <CustomHead
          keyword={'AI駆動開発 人材不足 開発コスト削減 DX モダナイゼーション AI活用'}
          image={'https://aitria.co.jp/img/ogp_logo.png'}
          url={'https://aitria.co.jp/download/ai-driven-development/done/'}
          title="ご入力いただきありがとうございます | 経営者が押さえておくべきAI駆動開発ハンドブック | 資料ダウンロード | Aitria（アイトリア）"
          description="ご入力いただいたメールアドレス宛に資料ダウンロード用URLを送付いたしました。メールをご確認いただき、資料をダウンロードしてください。"
          noindexNofollow={true}
        />
      )}
      <Template />
    </>
  )
}

export default DownloadCompleted
